import JustValidate from 'just-validate';
import {
	emailRules,
	getErrorContainer,
} from '../../assets/scripts/utils/validationRules';

class Mailing {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('.mailing');

		if (!this.container) {
			return;
		}

		const form = this.container.querySelector('.mailing__form');

		const inputs = {
			mailCheckbox: form.querySelector('[data-switcher="receive-email"] input'),
			telCheckbox: form.querySelector('[data-switcher="get-whatsapp"] input'),
			email: form.querySelector('#mailing-email'),
			tel: form.querySelector('#mailing-whatsapp'),
		};
		const mailOptions = inputs.mailCheckbox
			.closest('.popup__section-mobile')
			.querySelectorAll('.mailing__switches input');
		const telOptions = inputs.telCheckbox
			.closest('.popup__section-mobile')
			.querySelectorAll('.mailing__switches input');
		const submitButton = form.querySelector('.popup__submit');

		const emailValidator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});
		const whatsappValidator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});
		emailValidator.isValid = true;
		whatsappValidator.isValid = true;
		window.emailValidator = emailValidator;
		window.whatsappValidator = whatsappValidator;

		mailOptions.forEach((option) =>
			option.addEventListener('change', () => {
				if (option.checked) {
					inputs.mailCheckbox.checked = true;
					inputs.mailCheckbox.dispatchEvent(new Event('change'));
				}
			}),
		);

		telOptions.forEach((option) =>
			option.addEventListener('change', () => {
				if (option.checked) {
					inputs.telCheckbox.checked = true;
					inputs.telCheckbox.dispatchEvent(new Event('change'));
				}
			}),
		);

		inputs.mailCheckbox.addEventListener('change', (evt) => {
			if (evt.target.checked) {
				mailOptions.forEach((option) => {
					option.checked = true;
				});
				emailValidator.addField(inputs.email, emailRules, {
					errorsContainer: getErrorContainer(inputs.email),
				});
				emailValidator.validate();
			} else {
				mailOptions.forEach((option) => {
					option.checked = false;
				});
				emailValidator.removeField(inputs.email);
				emailValidator.isValid = true;
			}

			emailValidator.onValidate((errors) => {
				submitButton.disabled =
					!emailValidator.isValid || !whatsappValidator.isValid;
			});

			submitButton.disabled =
				!emailValidator.isValid || !whatsappValidator.isValid;
		});

		inputs.telCheckbox.addEventListener('change', (evt) => {
			if (evt.target.checked) {
				telOptions.forEach((option) => {
					option.checked = true;
				});
				whatsappValidator.addField(
					inputs.tel,
					[
						{
							rule: 'required',
							errorMessage: 'Обязательное поле',
						},
						{
							validator: (value, context) => {
								return (
									value.replace(/\D/g, '').length >
									context[1].elem.placeholder.replace(/\D/g, '').length - 1
								);
							},
							errorMessage: 'Неверный формат',
						},
					],
					{
						errorsContainer: getErrorContainer(inputs.tel),
					},
				);
				whatsappValidator.validate();
			} else {
				telOptions.forEach((option) => {
					option.checked = false;
				});
				whatsappValidator.removeField(inputs.tel);
				whatsappValidator.isValid = true;
			}

			whatsappValidator.onValidate((errors) => {
				submitButton.disabled =
					!emailValidator.isValid || !whatsappValidator.isValid;
			});

			submitButton.disabled =
				!emailValidator.isValid || !whatsappValidator.isValid;
		});
	}
}

export default new Mailing();
